<template lang="html">
  <v-form ref="form" lazy-validation autocomplete="off">
    <v-dialog v-model="dialogCadastroHierarquia" persistent max-width="800px">
      <hierarquia ref="hierarquia"
        :objeto="objeto"
        :somenteLeitura="somenteLeitura"
        @HIERARQUIA_INSERIDA="hierarquiaAdicionada"
        @HIERARQUIA_CANCELAR="hierarquiaCancelar"/>
    </v-dialog>
    <v-card>
      <v-card-title>
        {{ isNovoCadastro ? $t('title.cadastrar_novo_produto') : $t('title.editar_produto') }}
      </v-card-title>
      <div class="subtitle-1 ml-4">{{$t('label.preencha_campos_abaixo')}}</div>

      <v-container grid-list-xl fluid>
        <metadados-container-layout
          :metadados-entidade="metadadosProduto"
          :layout-class="layoutClass"
          :input-layout="inputLayout"
          :ordenacao-campos="isTenantEpoca ? ordenacaoSelecionada : []"
          :objeto="produto"
          :somenteLeitura="somenteLeitura"
          :novoCadastro="!isTenantEpoca"
          v-if="metadadosProduto"
          @MetadadosContainerLayout_abrirCadastro="novaHierarquia"
          ref="container">
          <v-col cols="12" sm="6" md="3" slot="antes">
            <v-text-field
              class="Form-text__invalid"
              id="produto_codigo"
              name="produto_codigo"
              :disabled="somenteLeitura"
              v-model="produto.idExterno"
              :label="`${$t('label.cod_produto')} *`"
              :counter="50"
              maxlength="50"
              :rules="[rules.required]">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" slot="antes">
            <v-text-field
              class="Form-text__invalid"
              id="produto_nome"
              name="produto_nome"
              :disabled="somenteLeitura"
              v-model="produto.nomProduto"
              :label="`${$t('label.nome')} *`"
              :counter="300"
              maxlength="300"
              :rules="[rules.required]">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" slot="antes">
            <v-text-field
              class="Form-text__invalid"
              id="produto_ean"
              name="produto_ean"
              :disabled="somenteLeitura"
              v-model="produto.ean"
              :label="$t('label.ean')"
              :counter="20"
              maxlength="20">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" slot="antes">
            <v-text-field
              class="Form-text__invalid"
              id="produto_volume"
              name="produto_volume"
              type="tel"
              min="0"
              :disabled="somenteLeitura"
              v-model="produto.volume"
              :label="`${$tc('label.volume', 1)} *`"
              :counter="12"
              :rules="[rules.required, rules.numeroValido]"
              :maxlength="12">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" slot="antes">
            <v-text-field
              class="Form-text__invalid"
              id="produto_peso"
              name="produto_peso"
              type="tel"
              min="0"
              :disabled="somenteLeitura"
              v-model="produto.peso"
              :label="`${$tc('label.peso', 1)} *`"
              :rules="[rules.required, rules.numeroValido]"
              :counter="12"
              :maxlength="12">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" slot="antes">
            <v-autocomplete
              id="produto_unidade_medida"
              name="produto_unidade_medida"
              v-model="produto.idUnidadeMedida"
              :disabled="somenteLeitura"
              :items="listaUnidadesMedida"
              :search-input.sync="buscaListaUnidadesMedida"
              @click.native="buscarUnidadesMedida"
              :no-data-text="$tc('message.nenhum_registro', 1)"
              item-text="nomUnidade"
              item-value="id"
              :label="`${$tc('label.unidade_medida', 1)} *`"
              clearable
              :rules="[rules.required]">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="3" slot="depois">
            <v-text-field
              class="Form-text__invalid"
              id="produto_ibm"
              name="produto_ibm"
              :disabled="somenteLeitura"
              v-model="produto.desIbm"
              :label="$t('label.ibm')"
              :counter="200"
              maxlength="200">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" slot="depois">
            <v-text-field
              class="Form-text__invalid"
              id="produto_modelo"
              name="produto_modelo"
              :disabled="somenteLeitura"
              v-model="produto.desModelo"
              :label="$t('label.referencia')"
              :counter="100"
              maxlength="100">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" slot="depois">
            <v-text-field
              class="Form-text__invalid"
              id="produto_grupo"
              name="produto_grupo"
              :disabled="somenteLeitura"
              v-model="produto.desGrupo"
              :label="$tc('label.grupo', 1)"
              :counter="100"
              maxlength="100">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" slot="depois">
            <v-text-field
              class="Form-text__invalid"
              id="produto_item_forn"
              name="produto_item_forn"
              :disabled="somenteLeitura"
              v-model="produto.desItemFornecedor"
              :label="$t('label.item_fornecedor')"
              :counter="100"
              maxlength="100">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" slot="depois">
            <v-text-field
              class="Form-text__invalid"
              id="produto_digito"
              name="produto_digito"
              :disabled="somenteLeitura"
              v-model="produto.digito"
              :label="$t('label.digito')"
              :counter="1"
              maxlength="1">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" slot="depois">
            <v-text-field
              class="Form-text__invalid"
              id="produto_cod_produto_pai"
              name="produto_cod_produto_pai"
              :disabled="somenteLeitura"
              v-model="produto.idExternoPai"
              :label="$t('label.cod_produto_pai')"
              :counter="50"
              maxlength="50"
              type="Number">
              <template v-slot:append-outer>
                <v-tooltip
                  bottom
                >
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">info</v-icon>
                  </template>
                  {{$t('message.ajuda.produto.cod_produto_pai')}}
                </v-tooltip>
            </template>
            </v-text-field>
          </v-col>
        </metadados-container-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click.native="cancel">{{ $t('label.cancelar') }}</v-btn>
        <v-btn v-if="!somenteLeitura" @click.native="abrirDialogSalvar" color="primary">{{ $t('label.salvar') }}</v-btn>
      </v-card-actions>
    </v-card>
    <confirm
      ref="confirmDialog"
      :message="$t('message.deseja_salvar', {text: $tc('label.produto', 1)})"
      :persistent="true"
      @agree="salvar">
    </confirm>
    <dialog-justificativa
      ref="dialogJustificativa"
      @confirmar="salvarJustificativa"
    >
    </dialog-justificativa>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import MetadadosContainerLayout from '@/shared-components/metadados/MetadadosContainerLayout';
import DialogJustificativa from '@/shared-components/dialog/DialogJustificativa';
import Confirm from '@/shared-components/dialog/Confirm';
import Hierarquia from '@/spa/produto/Hierarquia';
import { generateComputed } from '@/common/functions/roles-computed-generator';
import basePath from '@/common/functions/api-resource';
import { copyObject } from '@/common/functions/helpers';

export default {
  name: 'ProdutoForm',
  props: {
    copia: {
      type: Boolean,
      default: false,
    },
    somenteLeitura: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      buscaListaUnidadesMedida: null,
      dialog: {
        ref: 'dialog1',
        from: 'saveRegisterFromButton',
        title: this.$t('label.atencao'),
        content: '',
        action() {},
      },
      maiorIndice: null,
      menorIndice: null,
      objeto: {
        indAtivo: true,
      },
      notFoundNewHierarchy: false,
      dialogCadastroHierarquia: false,
      dialogConfirm: false,
      disableButton: false,
      formInvalido: false,
      idProduto: null,
      inputLayout: {
        xs12: true,
        sm12: false,
        md12: false,
        sm6: true,
        md3: true,
        md4: false,
        md6: false,
        md9: false,
      },
      layoutClass: { wrap: true },
      listaUnidadesMedida: [],
      produto: {
        ean: '',
        peso: '',
        volume: '',
        idUnidadeMedida: '',
        idExterno: '',
        nomProduto: '',
        desModelo: '',
        idExternoPai: '',
      },
      produtoCopy: {},
      produtoSalvar: {},
      ordenacaoSelecionada: [],
      resourceProduto: this.$api.produto(this.$resource),
      resourceMetadado: this.$api.metadado(this.$resource),
      rules: {
        required: (value) => ((!!value || Number(value) === 0) && value.toString().trim().length > 0 && value.toString().trim().length <= 300) || this.$t('message.campo_obrigatorio'),
        requiredMultiplaSelecao: (value) => (value && value.length > 0) || this.$t('message.campo_obrigatorio'),
        numeroValido: (value) => ((!!value || value === 0) && !Number.isNaN(value.toString().replace(',', '.')) && Number(value.toString().replace(',', '.')) >= 0) || this.$t('message.numero_invalido'),
      },
      unidadeMedidaResources: this.$api.unidadeMedida(this.$resource),
    };
  },
  watch: {
    buscaListaUnidadesMedida(val) {
      if (this.produto && this.produto.idUnidadeMedida) {
        const selecao = this.listaUnidadesMedida
          .filter((item) => item.id === this.produto.idUnidadeMedida);
        if (selecao.length > 0 && selecao[0].nomUnidade === val) {
          return;
        }
      }

      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(() => {
        if (val != null) this.buscarUnidadesMedida(val);
      }, 500);
    },
  },
  components: {
    Confirm,
    Hierarquia,
    MetadadosContainerLayout,
    DialogJustificativa,
  },
  computed: {
    ...mapGetters('metadados', [
      'getProdutoMetadado',
    ]),
    ...generateComputed('Prd', [
      'canAccessPage',
    ]),
    ...mapGetters('roles', [
      'getTenantId',
    ]),
    isTenantEpoca() {
      return this.getTenantId === 'epoca';
    },
    isNovoCadastro() {
      return !this.$route.params.id;
    },
    isPessoaJuridica() {
      return this.cliente.tipoPessoa === 'JURIDICA';
    },
    mapaCamposDinamicos() {
      if (this.getProdutoMetadado && this.getProdutoMetadado.mapaCamposDinamicos) {
        return this.getProdutoMetadado.mapaCamposDinamicos;
      }
      return [];
    },
    metadadosProduto() {
      if (this.getProdutoMetadado && this.getProdutoMetadado.mapaEntidades) {
        if (this.isTenantEpoca) {
          const produtoMetadado = copyObject(this.getProdutoMetadado);
          Object.values(produtoMetadado.mapaEntidades).forEach((entidade) => {
            entidade.recursiva = false;
            entidade.depObrigatoria = true;
            entidade.dependentes[0] = 'PRODUTO';
            entidade.dependencias = [];
            this.ordenacaoSelecionada.push(entidade.label);
          });
          return produtoMetadado;
        }
        return this.getProdutoMetadado;
      }
      return undefined;
    },
    nomeCompleto() {
      return `${this.produto.nome} ${this.produto.sobrenome}`;
    },
  },
  methods: {
    ...mapActions('metadados', [
      'setProdutoMetadado',
    ]),
    abrirDialogSalvar() {
      if (!this.$refs.form.validate()) return;
      this.abrirSalvar();
    },
    buscarMetadadosLabels() {
      return this.$api.nivelProduto(this.$resource).labels().then((resultado) => {
        this.tipos = resultado.data;
        this.maiorIndice = Math.max(...this.tipos.map((tipo) => tipo.indice));
        this.menorIndice = Math.min(...this.tipos.map((tipo) => tipo.indice));
        this.tipos.forEach((tipo) => {
          if (tipo.indice === this.menorIndice) {
            this.objeto.label = tipo.label;
            this.objeto.tipo = tipo.id;
            this.objeto.indice = tipo.indice;
          }
        });
        this.notFoundNewHierarchy = true;
      });
    },
    abrirSalvar() {
      if (this.verificaCamposAlterados()) {
        this.$refs.confirmDialog.open();
      } else {
        this.$refs.dialogJustificativa.open();
      }
    },
    verificaCamposAlterados() {
      if (!Object.keys(this.produtoCopy).length) {
        return true;
      }
      return this.produtoCopy.categoria.id === this.produto.categoria.id
      && this.produtoCopy.desIbm === this.produto.desIbm
      && this.produtoCopy.desModelo === this.produto.desModelo
      && this.produtoCopy.digito === this.produto.digito
      && this.produtoCopy.ean === this.produto.ean
      && this.produtoCopy.familia.id === this.produto.familia.id
      && this.produtoCopy.id === this.produto.id
      && this.produtoCopy.idExterno === this.produto.idExterno
      && this.produtoCopy.idUnidadeMedida === this.produto.idUnidadeMedida
      && this.produtoCopy.indAtivo === this.produto.indAtivo
      && this.produtoCopy.nomProduto === this.produto.nomProduto
      && this.produtoCopy.peso === this.produto.peso
      && this.produtoCopy.sigla_unidade_medida === this.produto.sigla_unidade_medida
      && this.produtoCopy.unidadenegocio === this.produto.unidadenegocio
      && this.produtoCopy.volume === this.produto.volume
      && this.produtoCopy.idExternoPai === this.produto.idExternoPai;
    },
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast('Acesso negado');
      }
    },
    buscarUnidadesMedida(busca = null) {
      const param = {
        nom_unidade: busca,
        tamanhoPagina: 50,
        numeroPagina: 0,
      };
      return this.unidadeMedidaResources.listarAtivos(param)
        .then((response) => {
          this.listaUnidadesMedida = response.data.resposta;
        });
    },
    cancel() {
      this.$router.push({ name: 'produto' });
    },
    carregarProduto(id) {
      this.resourceProduto.buscar({ id })
        .then((res) => {
          this.produto = { ...this.produto, ...res.body };
          this.produtoCopy = { ...this.produto, ...res.body };
          this.$emit('PRODUTOFORM_Carregado', this.produto);
          if (this.produto.idUnidadeMedida) {
            this.definirUnidadeMedida();
          }
          this.produto.volume = this.formatNumber(this.produto.volume);
          this.produto.peso = this.formatNumber(this.produto.peso);
          this.produtoCopy.volume = this.formatNumber(this.produto.volume);
          this.produtoCopy.peso = this.formatNumber(this.produto.peso);
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    formatNumber(item) {
      if (item === 0) {
        return 0;
      }
      return (item || '').toString().replace('.', ',');
    },
    definirUnidadeMedida() {
      this.buscarUnidadesMedida().then(() => {
        this.produto.regiao = this.listaUnidadesMedida
          .find((t) => t.id === this.produto.idUnidadeMedida) || {};
        this.$forceUpdate();
      });
    },
    closeDialog(ref, cb) {
      this.$refs[ref].close();
      if (cb) {
        cb();
      }
    },
    hierarquiaAdicionada(hierarquia, label) {
      this.produto[label] = hierarquia;
      this.dialogCadastroHierarquia = false;
      this.$refs.container.refresh();
      this.$toast(this.$t('message.atualizado_com_sucesso'));
    },
    hierarquiaCancelar() {
      this.dialogCadastroHierarquia = false;
    },
    limparExtensao(id) {
      if (entidade.manyToMany) {
        return;
      }
      this.produto[id] = null;
    },
    novaHierarquia() {
      this.dialogCadastroHierarquia = true;
      setTimeout(() => {
        this.$refs.hierarquia.setarTipos(this.tipos);
        this.$refs.hierarquia.setarObjeto(this.objeto);
      }, 1000);
      setTimeout(() => {
        this.$refs.hierarquia.buscarMetadadosLabels();
      }, 1000);
    },
    requestAtualizar(object, resource) {
      const { id } = object;

      resource({ id }, object)
        .then(() => {
          this.$toast(this.$t('message.atualizado_com_sucesso'));
          this.refreshViewProduto(id);
          this.$router.push({ name: 'produto' });
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    requestGravar(object, resource) {
      resource(object)
        .then((res) => {
          this.$toast(this.$t('message.adicionado_confira_tabela'));
          const { id } = res.body;
          this.refreshViewProduto(id);
          this.$router.push({ name: 'produto' });
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    refreshViewProduto(idProduto) {
      const urlView = basePath('api', 'compilador/views/produto');
      const path = `${urlView}/${idProduto}/refresh`;
      return this.executar(path);
    },
    executar(path) {
      return this.$http.post(path)
        .then(() => {
        });
    },
    requestPopularHeader() {
      if (this.getProdutoMetadado) {
        return;
      }
      this.setProdutoMetadado({
        resource: this.resourceMetadado.listarProduto,
      });
    },
    salvarJustificativa(justificativa) {
      this.produto.justificativaAlteracaoCampos = justificativa;
      this.salvar();
    },
    salvar() {
      this.produtoSalvar = {
        ...this.produto,
        ...this.$refs.container.getValoresDependencias(),
      };
      if (this.isTenantEpoca) {
        this.produtoSalvar.idCategoria = this.produtoSalvar.id_categoria;
        this.produtoSalvar.idFamilia = this.produtoSalvar.id_familia;
        this.produtoSalvar.idDivisaoFornecedor = this.produtoSalvar.id_divisao_fornecedor;
      }

      if (this.$route.params.id) {
        this.requestAtualizar(this.produtoSalvar, this.resourceProduto.atualizar);
      } else {
        this.requestGravar(this.produtoSalvar, this.resourceProduto.gravar);
      }
    },
    selecionaFetchExtensao(entidade) {
      return entidade.manyToMany
        ? this.prepareFetchExtensaoManyToMany(entidade.idNivelExtensao,
          this.produto[this.autocompleteModelAccess(entidade.campo)], entidade.campo)
        : this.prepareFetchExtensao(entidade.idNivelExtensao);
    },
  },
  beforeMount() {
    if (this.$route.params.id) {
      this.idProduto = parseInt(this.$route.params.id, 10);
    }
    if (!this.isNovoCadastro) {
      this.carregarProduto(this.$route.params.id);
    }
  },
  mounted() {
    if (!this.canAccessPage) {
      window.setTimeout(() => {
        this.accessForbidden();
        this.requestPopularHeader();
      }, 1E3);
      return;
    }
    this.requestPopularHeader();
    this.buscarMetadadosLabels();
  },
};
</script>

<style lang="css">
  .CLIENTEFORM__md-button {
    margin-top: 10px !important;
  }
</style>
